<template>
  <div class="container mt-4 mb-5">
    <div class="row">
      <div class="col-12 bread-crump-area">
        <ol>
          <li>
            <router-link :to="'/' + this.$store.state.langCodeX">
              {{ this.$store.getters.getWordLocale("txt_anasayfa") }} ▸
            </router-link>
          </li>
          <li>
            <router-link :to="'/' + this.$store.state.langCodeX + '/leads'">
              {{ this.$store.getters.getWordLocale("txt_talep_listesi") }} ▸
            </router-link>
          </li>
          <li>
            <span>{{ leadTitle }}</span>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="lead-detail-head-title col-xl-9 col-lg-12 m-0">
        <div
          class="
            d-flex d-flex
            align-items-center
            justify-content-between
            flex-column flex-md-row
            pt-3
          "
        >
          <div>
            <h2>{{ leadTitle }}</h2>
            <div class="leads-head-description">
              <abbr>
                <i class="material-icons-outlined"> card_travel </i>
                <span>{{
                  type == 0
                    ? this.$store.getters.getWordLocale("txt_alim_talebi")
                    : type == 1
                    ? this.$store.getters.getWordLocale("txt_satis_teklifi")
                    : this.$store.getters.getWordLocale("txt_isbirligi")
                }}</span>
              </abbr>
              <abbr v-if="credit > 0">
                <i class="material-icons-outlined"> copyright </i>
                <span>{{ credit }} Credit</span>
              </abbr>
              <abbr v-else class="lead-credit free">
                <i class="material-icons-outlined"> handshake </i>
                {{ this.$store.getters.getWordLocale("txt_ucretsiz") }}
              </abbr>

              <abbr>
                <i class="material-icons-outlined"> date_range </i>
                <span>{{ createDate }}</span>
              </abbr>

              <abbr>
                <i class="material-icons-outlined"> schedule </i>
                <span>{{ createTime }}</span>
              </abbr>
              <abbr>
                <i class="material-icons-outlined"> flag </i>
                <span>{{ countryName }}</span>
              </abbr>
            </div>
          </div>
          <div class="did-floating-label-content language-select-area">
            <i class="material-icons-outlined">translate</i>
            <select
              @change="changeLanguage($event.target.value.toLowerCase())"
              class="did-floating-select form-control"
            >
              <option value="">
                {{
                  this.$store.state.languagesNamesX.filter(
                    (q) => q.code == this.$store.state.langCodeX
                  )[0].name
                }}
              </option>
              <option
                v-for="(language, index) in this.$store.state.domainLanguages"
                :key="index"
                v-show="language.LangCode != this.$store.state.langCodeX"
                :value="language.LangCode"
              >
                {{
                  this.$store.state.languagesNamesX.filter(
                    (q) => q.code == language.LangCode
                  )[0].name
                }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_dili_degistir")
            }}</label>
          </div>
        </div>

        <div class="row lead-detail-information-area col-12 row m-0 mt-4 p-0">
          <div class="col-xl-12 mt-3">
            <div class="lead-detail-information-left-box">
              <div class="info-item">
                <abbr
                  ><i class="material-icons-outlined">message</i
                  ><strong>{{
                    this.$store.getters.getWordLocale("txt_ozet")
                  }}</strong></abbr
                >
                <p>
                  {{ leadSummary }}
                </p>
              </div>

              <div class="row mt-4" v-show="showLoader">
                <ForieLoader
                  class="lead-d-loader"
                  v-show="showLoader && this.$store.state.domainSystemX == 1"
                />
                <TeLoader
                  class="lead-d-loader"
                  v-show="showLoader && this.$store.state.domainSystemX == 2"
                />
              </div>

              <div v-show="canViewLead" class="row mt-4">
                <div class="col-xl-6 col-md-12">
                  <div class="info-item">
                    <abbr
                      ><i class="material-icons-outlined">contact_phone</i
                      ><strong>Contact Information</strong></abbr
                    >
                    <div class="lead-detail-contact-information-list">
                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>Name Surname</b>
                          <span>{{ nameSurname }}</span></abbr
                        >
                      </div>
                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>Company Name</b>
                          <span
                            v-bind:class="{ unknown: companyName == '-' }"
                            >{{
                              companyName == "-"
                                ? this.$store.getters.getWordLocale(
                                    "txt_bilirtilmemis"
                                  )
                                : companyName
                            }}</span
                          ></abbr
                        >
                      </div>
                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>Phone</b>
                          <span v-bind:class="{ unknown: phone == '-' }">{{
                            phone == "-"
                              ? this.$store.getters.getWordLocale(
                                  "txt_bilirtilmemis"
                                )
                              : phone
                          }}</span>
                        </abbr>
                      </div>
                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>E-mail</b>
                          <span v-bind:class="{ unknown: email == '-' }">{{
                            email == "-"
                              ? this.$store.getters.getWordLocale(
                                  "txt_bilirtilmemis"
                                )
                              : email
                          }}</span>
                        </abbr>
                      </div>
                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>Fax</b>
                          <span v-bind:class="{ unknown: fax == '-' }">{{
                            fax == "-"
                              ? this.$store.getters.getWordLocale(
                                  "txt_bilirtilmemis"
                                )
                              : fax
                          }}</span>
                        </abbr>
                      </div>
                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>Website</b>
                          <span v-bind:class="{ unknown: webAddress == '-' }">{{
                            webAddress == "-"
                              ? this.$store.getters.getWordLocale(
                                  "txt_bilirtilmemis"
                                )
                              : webAddress
                          }}</span>
                        </abbr>
                      </div>

                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>Country</b>
                          <span
                            v-bind:class="{ unknown: countryName == '-' }"
                            >{{
                              countryName == "-"
                                ? this.$store.getters.getWordLocale(
                                    "txt_bilirtilmemis"
                                  )
                                : countryName
                            }}</span
                          >
                        </abbr>
                      </div>
                      <div class="lead-detail-contact-information-item">
                        <abbr>
                          <b>Address</b>
                          <span v-bind:class="{ unknown: address == '-' }">{{
                            address == "-"
                              ? this.$store.getters.getWordLocale(
                                  "txt_bilirtilmemis"
                                )
                              : address
                          }}</span>
                        </abbr>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-show="leadDocuments.length > 0"
                  class="col-xl-6 col-md-12"
                >
                  <div class="info-item">
                    <abbr
                      ><i class="material-icons-outlined">topic</i
                      ><strong>Documantation</strong></abbr
                    >
                    <div class="documents-area">
                      <a
                        v-for="(file, fIndex) in leadDocuments"
                        :key="fIndex"
                        :class="'documents-item ' + file.icon"
                        :href="file.file"
                      >
                        <abbr
                          ><i :class="'far fa-file-' + file.icon"></i>
                        </abbr>
                        <span>{{ file.name }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="canViewLead" class="info-item mt-4">
                <abbr
                  ><i class="material-icons-outlined">message</i
                  ><strong>{{
                    this.$store.getters.getWordLocale("txt_mesaj")
                  }}</strong></abbr
                >

                <p>
                  {{ leadMessage }}
                </p>
              </div>

              <div v-if="!this.$store.state.userLoggedInX" class="go-login-box">
                <i class="material-icons-outlined">lock</i>
                <span>{{
                  this.$store.getters.getWordLocale(
                    "txt_talep_detay_icin_giris_yap"
                  )
                }}</span>

                <div class="d-flex flex-wrap go-login-box-btn-area">
                  <a
                    class="btn lead-detail-sign-up-btn"
                    :href="this.$store.state.signUpUrlX"
                    >{{ this.$store.getters.getWordLocale("txt_uye_ol") }}</a
                  >
                  <a
                    class="btn lead-detail-log-in-btn"
                    :href="
                      this.$store.state.loginUrlX +
                      '/' +
                      this.$store.state.langCodeX +
                      '?apilogin=true&returnUrl=' +
                      this.$store.state.currentUrlX
                    "
                    ><i class="material-icons-outlined"> verified_user </i>
                    {{ this.$store.getters.getWordLocale("txt_giris_yap") }}</a
                  >
                </div>
              </div>
              <div></div>
              <div
                v-show="
                  canViewLead == false &&
                  notFound == false &&
                  this.$store.state.userLoggedInX == true &&
                  showLoader == false
                "
                class="credit-is-required-for-the-request-box"
              >
                <i class="material-icons-outlined"> shopping_cart </i>
                <strong v-if="credit > 0">{{
                  this.$store.getters.getWordLocale(
                    "txt_kredi_gerektiren_talep"
                  )
                }}</strong>
                <strong v-else>{{
                  this.$store.getters.getWordLocale(
                    "txt_gosterme_hakki_kullanilmali"
                  )
                }}</strong>
                <span v-if="credit > 0">{{
                  this.$store.getters.getWordLocale("txt_lead_kredi_harcamali")
                }}</span>
                <span v-else>{{
                  this.$store.getters.getWordLocale("txt_lead_hak_kullanilmali")
                }}</span>
                <div
                  class="credit-is-required-area"
                  v-show="gettingUserCompanies == true"
                >
                  <i class="fa fa-spinner fa-spin fa-2x text-info"></i>
                </div>

                <div
                  v-show="
                    this.$store.state.domainSystemX == 2 &&
                    hasPublishedCompany == false &&
                    companiesListDone == true
                  "
                  class="mt-2 text-center alert alert-danger"
                >
                  <i class="fa fa-info-circle"></i>
                  {{
                    this.$store.getters.getWordLocale(
                      "txt_yayinda_firmaniz_olmali"
                    )
                  }}
                </div>

                <div
                  v-show="gettingUserCompanies == false"
                  class="credit-is-required-area"
                >
                  <select
                    @change="setSelectedCompanyToBuyLead($event)"
                    class="form-select"
                    aria-label="Default select"
                  >
                    <option selected disabled>
                      {{ this.$store.getters.getWordLocale("txt_firma_sec") }}
                    </option>
                    <option
                      v-for="(company, cIndx) in userCompanies"
                      :key="cIndx"
                      :credit="company.creditToSpend"
                      :value="company.companyId"
                    >
                      {{ company.name }}
                    </option>
                  </select>

                  <a
                    v-show="
                      selectedCompanyId > 0 && credit > 0 && hasPublishedCompany
                    "
                    v-on:click="selectCompanyToBuyLead"
                    class="btn btn-on-primary"
                    v-if="companyCreditToSpend > 0"
                    href="javascript:;"
                    >{{
                      this.$store.getters
                        .getWordLocale("txt_rakam_kredi_ode")
                        .replace("{1}", companyCreditToSpend)
                    }}
                    <span
                      v-show="buyingLead"
                      class="fa ms-1 fa-spinner fa-spin"
                    ></span
                  ></a>

                  <a
                    v-show="
                      selectedCompanyId > 0 && credit > 0 && hasPublishedCompany
                    "
                    class="btn btn-not-enough"
                    v-else
                    >{{
                      this.$store.getters.getWordLocale("txt_yetersiz_kredi")
                    }}
                    !
                  </a>

                  <a
                    v-show="
                      selectedCompanyId > 0 &&
                      credit == 0 &&
                      hasPublishedCompany
                    "
                    v-on:click="selectCompanyToViewLead"
                    v-bind:class="{
                      'btn btn-on-primary': true,
                      disabled: remaningViewCount == 0,
                    }"
                    href="javascript:;"
                  >
                    {{ this.$store.getters.getWordLocale("txt_kalan_hakki") }}:
                    {{ remaningViewCount }}/{{ viewRightCount }}
                  </a>

                  <div class="ms-2" v-show="buyingLead">
                    <span
                      class="fa ms-1 fa-2x fa-spinner text-info fa-spin"
                    ></span>
                  </div>
                </div>
              </div>
              <div v-show="notFound" class="go-login-box mt-2 f-20">
                <i class="fa fa-info-circle"></i>
                {{ this.$store.getters.getWordLocale("txt_talep_bulunamadi") }}
              </div>
              <div class="info-item mt-4">
                <abbr
                  ><i class="material-icons-outlined">tag</i
                  ><strong>{{
                    this.$store.getters.getWordLocale("txt_kategorileri")
                  }}</strong></abbr
                >
                <div class="categories-box">
                  <a
                    v-for="(cat, cIndex) in leadCategoriesData"
                    :key="cIndex"
                    href="javscript:;"
                    class="categories-item"
                    >{{ cat.categoryName }}</a
                  >
                </div>
              </div>

              <div class="similar-lead-list-page">
                <h3>
                  {{ this.$store.getters.getWordLocale("txt_benzer_talepler") }}
                </h3>
                <div>
                  <ForieLoader
                    class="lead-d-loader"
                    v-show="
                      this.$store.state.domainSystemX == 1 &&
                      similarLeadsLoad == true
                    "
                  />
                  <TeLoader
                    class="lead-d-loader"
                    v-show="
                      this.$store.state.domainSystemX == 2 &&
                      similarLeadsLoad == true
                    "
                  />
                </div>

                <div
                  v-for="(lead, lIndex) in similarLeadListData"
                  :key="lIndex"
                  class="similar-lead-item"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="
                          d-flex
                          flex-column
                          item-description
                          lead-item-top
                        "
                      >
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <a class="d-flex align-items-center">
                            <country-flag
                              :country="lead.countryCode"
                              size="normal"
                            />
                            <span>{{ lead.countryName }}</span>
                          </a>

                          <abbr class="d-flex date-box"
                            ><b>{{ lead.createTime }}</b></abbr
                          >
                        </div>
                        <a :href="lead.link">{{ lead.title }}</a>
                        <p>
                          {{ lead.summary }}
                        </p>

                        <ul>
                          <li>
                            <span class="material-icons-outlined">
                              card_travel </span
                            ><abbr
                              >
                              {{
                                lead.leadType == 0
                                  ? this.$store.getters.getWordLocale(
                                      "txt_alim_talebi"
                                    )
                                  : lead.leadType == 1
                                  ? this.$store.getters.getWordLocale(
                                      "txt_satis_teklifi"
                                    )
                                  : this.$store.getters.getWordLocale(
                                      "txt_isbirligi"
                                    )
                              }}
                            </abbr>
                          </li>
                          <li v-if="lead.credit > 0">
                            <span class="material-icons-outlined">
                              copyright
                            </span>
                            <abbr
                              >{{ lead.credit }}
                              {{
                                this.$store.getters.getWordLocale("txt_kredi")
                              }}</abbr
                            >
                          </li>
                          <li v-else>
                            <span class="material-icons-outlined">
                              handshake
                            </span>
                            <abbr>{{
                              this.$store.getters.getWordLocale("txt_ucretsiz")
                            }}</abbr>
                          </li>
                          <li>
                            <span class="material-icons-outlined">
                              schedule
                            </span>
                            <abbr>{{ lead.createTime }}</abbr>
                          </li>
                          <li>
                            <span class="material-icons-outlined"> flag </span
                            ><abbr>{{ lead.countryName }}</abbr>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  style="height: 70px"
                  v-show="currentPage > 0 && showMoreLoader"
                >
                  <ForieLoader
                    class="more-svg"
                    v-show="this.$store.state.domainSystemX == 1"
                  />
                  <TeLoader
                    class="more-svg"
                    v-show="this.$store.state.domainSystemX == 2"
                  />
                </div>

                <div
                  v-show="
                    noMoreLeads == false && similarLeadListData.length > 0
                  "
                >
                  <div
                    class="d-flex justify-content-center more-company-box mb-4"
                  >
                    <a
                      v-on:click="
                        getSimilarAndLastDayLeads(currentPage + 1, false)
                      "
                      href="javascript:;"
                      class="btn btn-large-primary-button"
                      >{{
                        this.$store.getters.getWordLocale(
                          "txt_daha_fazla_yukle"
                        )
                      }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="last24HoursLeadsList.length > 0"
        class="col-xl-3 lead-detail-information-right-col d-none d-xl-block"
      >
        <div class="lead-detail-information-right-box">
          <h4>{{ this.$store.getters.getWordLocale("txt_son_24_saat") }}</h4>
          <div class="last-24-hours-list">
            <div
              v-for="(lead, lIndex) in last24HoursLeadsList"
              :key="lIndex"
              class="last-24-hours-item"
            >
              <a :href="lead.link">{{ lead.title }}</a>
              <div class="d-flex request-and-schedule-area">
                <abbr>
                  <i class="material-icons-outlined me-1">card_travel</i>
                  <span>
                    {{
                      lead.leadType == 0
                        ? this.$store.getters.getWordLocale("txt_alim_talebi")
                        : lead.leadType == 1
                        ? this.$store.getters.getWordLocale("txt_satis_teklifi")
                        : this.$store.getters.getWordLocale("txt_isbirligi")
                    }}
                  </span>
                </abbr>
                <abbr>
                  <i class="material-icons-outlined me-1">schedule</i>
                  <span>{{ lead.createTime }}</span>
                </abbr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountryFlag from "vue-country-flag-next";
import moment from "moment";
import helper from "./helper.js";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

export default {
  components: {
    ForieLoader,
    TeLoader,
    CountryFlag,
  },
  data() {
    return {
      similarLeadsLoad: true,
      noMoreLeads: false,
      currentPage: 0,
      selectedLeadTypes: [],
      keywords: "",
      selectedLeads: [],
      selectedCategories: [],
      selectedMainAndSubCategories: [],
      selectedCountries: [],
      previousDayDate: "",
      skipValueLeads: 0,
      last24HoursLeadsList: [],
      similarLeadListData: [],
      leadsList: [],
      remaningViewCount: 0,
      viewRightCount: 0,
      buyingLead: false,
      showLoader: true,
      showMoreLoader: false,
      companySelected: false,
      companyCreditToSpend: 0,
      selectedCompanyId: 0,
      companiesListDone: false,
      hasPublishedCompany: false,
      viewCount: 0,
      leadDocuments: [],
      isLeadBought: false,
      isLeadInBulletin: false,
      gettingUserCompanies: true,
      userCompanies: [],
      notFound: false,
      isLoadingDone: false,
      leadMessage: "",
      nameSurname: "",
      companyName: "",
      address: "",
      fax: "",
      email: "",
      country: "",
      webAddress: "",
      phone: "",
      canViewLead: false,
      leadDetailsFullData: [],
      leadCategories: [],
      leadCategoriesData: [],
      createDate: "",
      createTime: "",
      countryName: "",
      countryCode: "",
      loadDone: false,
      type: null,
      credit: null,
      leadSummary: "",
      leadTitle: "",
      leadId: 0,
    };
  },
  methods: {
    changeLanguage(langCode) {
      this.$store.state.langCodeX = langCode;
    },
    async getLead() {
      this.showLoader = true;

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getLead`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            leadId: parseInt(this.leadId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.leadDetails = data))
        .catch((err) => console.log(err.message));

      this.leadDetailsFullData = this.leadDetails;
      if (this.leadDetails == null) {
        window.location.href = `/${this.$store.state.langCodeX}/not-found`;
      }

      this.leadTitle =
        this.leadDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Title
          : this.leadDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Title;

      this.$store.state.detailsTitleX = this.leadTitle;

      this.leadSummary =
        this.leadDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].ShortDescription
          : this.leadDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].ShortDescription;

      this.$store.state.detailsDescriptionX = this.leadSummary;

      this.leadKeywords =
        this.leadDetailsFullData.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Keywords
          : this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Keywords;
      this.leadKeywords =
        this.leadKeywords != null ? this.leadKeywords.split(",") : [];
      this.type = parseInt(this.leadDetails.Type);
      this.credit = parseInt(this.leadDetails.Credit);

      this.countryName =
        this.leadDetails.Country.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length == 0
          ? this.leadDetails.Country.filter((q) => q.LangCode == "en").length ==
            0
            ? this.leadDetails.Country.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : this.leadDetails.Country.filter((q) => q.LangCode == "en")[0].Name
          : this.leadDetails.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name;

      this.countryCode =
        this.leadDetails.Country[0] != null &&
        this.leadDetails.Country[0] != undefined
          ? this.leadDetails.Country[0].Icon
          : "";

      const dateObject = new Date(this.leadDetails.PublishTime);

      this.leadDetails.Categories.forEach((element) => {
        var categoryId = parseInt(element.SubCategoryId);
        this.leadCategories.push(categoryId);
      });

      if (this.leadCategories.length > 0) {
        this.getSubCategoryNames();
      }

      this.createDate = dateObject.toLocaleString("tr-TR");
      this.createTime = this.createDate.split(" ")[1];
      this.createDate = this.createDate.split(" ")[0];

      this.loadDone = true;
    },
    async getLeadDetails(fromBuy) {
      var accessToken = helper.getCookie("fn_access_token");
      var result = [];
      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/getLead?leadId=${this.leadId}&displayLang=${this.$store.state.langCodeX}&systemId=${this.$store.state.domainSystemX}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.showLoader = false;
      this.isLoadingDone = true;

      if (result != "") {
        if (result.resultText == "Success") {
          this.viewCount = result.responseObject.lead.viewCount;

          if (
            result.responseObject.company != [] &&
            result.responseObject.company != undefined &&
            result.responseObject.company != null
          ) {
            this.isLeadBought = result.responseObject.lead.isPurchased;
            if (this.isLeadBought == false) {
              this.isLeadInBulletin = result.responseObject.lead.sendAsBulletin;
            }

            this.leadMessage = result.responseObject.lead.description;
            this.nameSurname = result.responseObject.company.userName ?? "-";
            this.companyName = result.responseObject.company.name ?? "-";
            this.address = result.responseObject.company.address ?? "-";

            this.fax = result.responseObject.company.fax ?? "-";
            this.email = result.responseObject.company.email ?? "-";
            this.country = result.responseObject.company.countryName ?? "-";
            this.webAddress = result.responseObject.company.webSite ?? "-";
            this.phone = result.responseObject.company.phone ?? "-";

            this.leadDocuments = [];
            if (
              result.responseObject.documents != undefined &&
              result.responseObject.documents != null
            ) {
              result.responseObject.documents.forEach((element) => {
                var file = element.file;
                var arr = element.file.split("/");
                var name = arr[arr.length - 1];
                var fileType = file.split(".")[file.split(".").length - 1];

                var fileIcon = "";
                if (
                  fileType == "jpg" ||
                  fileType == "png" ||
                  fileType == "JPEG"
                ) {
                  fileIcon = "image";
                }
                if (fileType == "pdf") {
                  fileIcon = "pdf";
                }

                if (
                  fileType == "docx" ||
                  fileType == "dot" ||
                  fileType == "doc" ||
                  fileType == "txt"
                ) {
                  fileIcon = "word";
                }

                if (
                  fileType == "xls" ||
                  fileType == "xlsb" ||
                  fileType == "xlsm" ||
                  fileType == "xlsx"
                ) {
                  fileIcon = "excel";
                }

                this.leadDocuments.push({
                  file: file,
                  name: name,
                  icon: fileIcon,
                });
              });
            }

            this.canViewLead = true;
            this.selectedCompanyId = 0;

            if (fromBuy) {
              this.$swal({
                position: "top-end",
                icon: "success",
                title: `${this.$store.getters.getWordLocale(
                  "txt_talep_satin_alindi"
                )}`,
                showConfirmButton: false,
                toast: true,
                timer: 3000,
              });
            }
          } else {
            this.canViewLead = false;
            this.getUserCompanies();
          }
        } else {
          this.canViewLead = false;
          this.notFound = true;
        }

        this.buyingLead = false;
      }
    },
    async getSubCategoryNames() {
      var leadCategoriesList = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getSubCategoryNames`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoryIdList: this.leadCategories,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (leadCategoriesList = data))
        .catch((err) => console.log(err.message));

      if (leadCategoriesList != undefined && leadCategoriesList.length > 0) {
        leadCategoriesList.forEach((element) => {
          var leadId = parseInt(element._id);
          var categoryName =
            element.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : element.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          var slug =
            element.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Slug
              : element.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Slug;

          this.leadCategoriesData.push({
            id: leadId,
            categoryName: categoryName,
            slug: slug,
          });
        });
      }

      this.getSimilarAndLastDayLeads(0, false);
    },
    async getUserCompanies() {
      var accessToken = helper.getCookie("fn_access_token");
      var result = [];
      this.gettingUserCompanies = true;

      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/getMyCompaniesToBuyLead?leadId=${this.leadId}&lang=${this.$store.state.langCodeX}&systemId=${this.$store.state.domainSystemX}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.gettingUserCompanies = false;
      if (result != "") {
        if (result.resultText == "Success") {
          if (result.responseObject.length > 0) {
            this.userCompanies = [];
            result.responseObject.forEach((element) => {
              var companyId = element.id;
              var name = element.name;
              var creditToSpend = element.creditToSpend;
              var totalCredit = element.totalCredit;
              var userHasPermissionToBuyLead =
                element.userHasPermissionToBuyLead;
              var outOfCategory = element.outOfCategory;

              if (this.$store.state.domainSystemX == 2) {
                if (element.isPublished) {
                  this.hasPublishedCompany = true;
                }
              } else {
                this.hasPublishedCompany = true;
              }

              this.userCompanies.push({
                companyId: companyId,
                name: name,
                creditToSpend: creditToSpend,
                totalCredit: totalCredit,
                userHasPermissionToBuyLead: userHasPermissionToBuyLead,
                outOfCategory: outOfCategory,
                remaningViewCount: element.viewedFreeLeadsCount,
                viewRightCount: element.readFreeLeadsCount,
                isPublished: element.isPublished,
                isBanned: element.isBanned,
              });
            });

            this.companiesListDone = true;
          }
        } else {
          console.log(result);
        }
      }
    },
    setSelectedCompanyToBuyLead(e) {
      this.selectedCompanyId = parseInt(e.target.value);

      var totalCredit = (this.companyCreditToSpend = this.userCompanies.filter(
        (q) => q.companyId == this.selectedCompanyId
      )[0].totalCredit);

      var creditToSpend = (this.companyCreditToSpend =
        this.userCompanies.filter(
          (q) => q.companyId == this.selectedCompanyId
        )[0].creditToSpend);

      if (totalCredit < creditToSpend) {
        this.companyCreditToSpend = 0;
      } else {
        this.companyCreditToSpend = creditToSpend;
      }

      this.remaningViewCount = this.userCompanies.filter(
        (q) => q.companyId == this.selectedCompanyId
      )[0].remaningViewCount;

      this.viewRightCount = this.userCompanies.filter(
        (q) => q.companyId == this.selectedCompanyId
      )[0].viewRightCount;

      this.companySelected = true;
    },
    async selectCompanyToBuyLead() {
      if (this.selectedCompanyId == 0) {
        return;
      }
      if (this.buyingLead == true) {
        return;
      }
      var companyInfo = this.userCompanies.filter(
        (q) => q.companyId == this.selectedCompanyId
      )[0];

      if (companyInfo.outOfCategory == true) {
        this.$swal({
          title: `${this.$store.getters.getWordLocale("txt_uyari")}`,
          html: `${this.$store.getters.getWordLocale(
            "txt_uyari_farkli_kategori_talep"
          )}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: `${this.$store.getters.getWordLocale("txt_hayir")}`,
          confirmButtonText: `${this.$store.getters.getWordLocale("txt_evet")}`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.buyLead(this.selectedCompanyId);
          }
        });
      } else {
        this.buyLead(this.selectedCompanyId);
      }
    },
    async buyLead(companyId) {
      this.selectedCompanyId = companyId;
      var result = [];
      var accessToken = helper.getCookie("fn_access_token");
      this.buyingLead = true;
      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/BuyLead?leadId=${this.leadId}&lang=${this.$store.state.langCodeX}&companyIdToBuy=${companyId}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      if (result.resultText == "Success") {
        this.getLeadDetails(true);
      } else {
        this.selectedCompanyId = 0;
        this.buyingLead = false;
        this.$swal({
          position: "top-end",
          icon: "warning",
          text: result.message,
          showConfirmButton: false,
          toast: true,
          timer: 3000,
        });
      }
    },

    selectCompanyToViewLead() {
      if (this.buyingLead == true) {
        return;
      }
      if (this.selectedCompanyId == 0) {
        return;
      }
      this.buyingLead = true;
      this.viewLead(this.selectedCompanyId);
    },
    async viewLead(companyId) {
      this.selectedCompanyId = companyId;
      var result = [];
      var accessToken = helper.getCookie("fn_access_token");

      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/ViewLead?leadId=${this.leadId}&lang=${this.$store.state.langCodeX}&companyIdToBuy=${companyId}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      if (result.resultText == "Success") {
        this.getLeadDetails(true);
      } else {
        this.buyingLead = false;
        this.selectedCompanyId = 0;
        this.$swal({
          position: "top-end",
          icon: "warning",
          text: result.message,
          showConfirmButton: false,
          toast: true,
          timer: 3000,
        });
      }
    },
    async getSimilarAndLastDayLeads(page, last24Hour) {
      if (page > 0) {
        this.showMoreLoader = true;
      }

      this.currentPage = page;
      if (this.currentPage == 0) {
        if (last24Hour) {
          this.last24HoursLeadsList = [];
        } else {
          this.similarLeadListData = [];
        }
        this.skipValueLeads = 0;
      } else {
        this.skipValueLeads = this.currentPage * 20;
      }

      this.$store.state.searchInputValueX = "";

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getLeadsListForDomains`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domainSystem: this.$store.state.domainSystemX,
            selectedLeadType:
              this.selectedLeadType == -1 ? null : this.selectedLeadType,
            keywords: this.keywords.length == 0 ? null : this.keywords,
            selectedCategories: last24Hour
              ? this.selectedCategories.length == 0
                ? null
                : this.selectedCategories
              : this.leadCategories,
            selectedMainCategories: null,
            selectedLeads:
              this.selectedLeads.length == 0 ? null : this.selectedLeads,
            selectedCountries:
              this.selectedCountry > 0
                ? [this.selectedCountry]
                : this.selectedCountries.length == 0
                ? null
                : this.selectedCountries,
            search: this.$store.state.searchInputValueX,
            page: this.skipValueLeads,
            selectedLeadTypes: this.selectedLeadTypes,
            lastDay: last24Hour ? this.previousDayDate : null,
            limit: last24Hour ? 25 : null,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.leadsList = data))
        .catch((err) => console.log(err.message));

      if (this.leadsList.length < 20) {
        this.noMoreLeads = true;
      } else {
        this.noMoreLeads = false;
      }

      this.leadsList.forEach((element) => {
        var leadTitle =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Title
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Title;

        const dateObject = new Date(element.PublishTime);
        var createTime = dateObject.toLocaleString("tr-TR");

        var endDate = moment(new Date()).format("DD.MM.YYYY HH:mm:ss");
        endDate = moment(endDate, "DD.MM.YYYY HH:mm:ss");
        createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss");

        var diff = endDate.diff(createTime, "days");
        if (diff == 0) {
          createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss").fromNow();
        } else {
          createTime = dateObject.toLocaleString("tr-TR");
        }

        var leadId = parseInt(element._id);
        var leadType = parseInt(element.Type);
        var credit = parseInt(element.Credit);
        var countryName =
          element.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length == 0
            ? element.Country.filter((q) => q.LangCode == "en").length == 0
              ? element.Country.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name
              : element.Country.filter((q) => q.LangCode == "en")[0].Name
            : element.Country.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name;
        var countryCode =
          element.Country[0] != null && element.Country[0] != undefined
            ? element.Country[0].Icon
            : "";

        var leadSummary =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].ShortDescription
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].ShortDescription;
        leadSummary =
          leadSummary == null
            ? ""
            : leadSummary.length > 150
            ? `${leadSummary.substr(0, 150)}...`
            : leadSummary;

        var leadKeywords =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Keywords
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Keywords;
        leadKeywords = leadKeywords.split(",");
        var link = element.LinkString;
        if (last24Hour == false) {
          if (this.leadId != leadId) {
            this.similarLeadListData.push({
              id: leadId,
              title: leadTitle,
              link: link,
              createTime: createTime,
              countryName: countryName,
              countryCode:
                countryCode !== null ? countryCode.toLowerCase() : "",
              summary: leadSummary,
              keywords: leadKeywords,
              leadType: leadType,
              credit: credit,
            });
          }
        } else {
          if (this.leadId != leadId) {
            this.last24HoursLeadsList.push({
              id: leadId,
              title: leadTitle,
              link: link,
              createTime: createTime,
              countryName: countryName,
              countryCode:
                countryCode !== null ? countryCode.toLowerCase() : "",
              summary: leadSummary,
              keywords: leadKeywords,
              leadType: leadType,
              credit: credit,
            });
          }
        }
      });
      this.$store.state.isSearchChangedX = false;
      this.showMoreLoader = false;
      if (last24Hour == false) {
        this.similarLeadsLoad = false;
      }
    },
  },
  mounted() {
    this.previousDayDate = moment(new Date())
      .subtract(1, "days")
      .format("YYYY-MM-DD");

    moment.locale(`${this.$store.state.langCodeX}`);
    this.leadId = helper.getCompanyId(this.$route.params.id);
    this.getLead();

    if (this.$store.state.userLoggedInX) {
      this.getLeadDetails(false);
    } else {
      this.showLoader = false;
      this.isLoadingDone = true;
    }

    // #region LeadsFilter
    var leadContentX = this.$store.state.domainContentX.LeadContent;
    var keywords = leadContentX.Keywords;

    var selectedCategories = leadContentX.SelectedCategories;
    var selectedLeads = leadContentX.SelectedLeads;
    var selectedCountries = leadContentX.SelectedCountries;
    this.selectedLeadTypes = leadContentX.SelectedLeadTypes;
    if (this.selectedLeadTypes.length > 0) {
      var temp = [];
      this.selectedLeadTypes.forEach((element) => {
        var type = parseInt(element);
        temp.push(type);
      });
      this.selectedLeadTypes = [];
      this.selectedLeadTypes = temp;
    }

    if (keywords.length > 0) {
      this.keywords = [];
      keywords.forEach((element) => {
        var text = element.text;
        this.keywords.push(text);
      });
    }

    if (selectedLeads.length > 0) {
      this.selectedLeads = [];
      selectedLeads.forEach((element) => {
        var leadId = parseInt(element.id);
        this.selectedLeads.push(leadId);
      });
    }

    if (selectedCategories.length > 0) {
      this.selectedCategories = [];
      selectedCategories.forEach((element) => {
        var categoryId = parseInt(element.categoryId);
        var mainCategoryId = parseInt(element.mainCategoryId);

        this.selectedCategories.push(categoryId);
        this.selectedMainAndSubCategories.push({
          mainCategoryId: mainCategoryId,
          categoryId: categoryId,
        });
      });
    }

    if (selectedCountries.length > 0) {
      this.selectedCountries = [];
      selectedCountries.forEach((element) => {
        var countryId = parseInt(element);
        this.selectedCountries.push(countryId);
      });
    }

    // #endregion

    this.getSimilarAndLastDayLeads(0, true);
  },
};
</script>
<style lang="postcss">
.more-svg {
  background: transparent !important;
}

.more-svg svg {
  width: 70px !important;
}
</style>
<style scoped>
.did-floating-label-content {
  position: relative;
  min-width: 187px;
}
.did-floating-label {
  color: #1e4c82;
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 20px;
  padding: 0 5px;
  background: var(--m3--sys--light--on-primary);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.did-floating-input,
.did-floating-select {
  font-size: 12px;
  display: block;
  width: 100%;
  height: 56px;
  padding: 0 20px;
  background: var(--m3--sys--light--on-primary);
  border-radius: 4px;
  box-sizing: border-box;

  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.5px;

  /* M3/sys/light/on-surface */
  color: var(--m3--sys--light--on-surface-variant);
}
.did-floating-input:focus,
.did-floating-select:focus {
  outline: none;
  box-shadow: none !important;
}
.did-floating-input:focus ~ .did-floating-label,
.did-floating-select:focus ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
select.did-floating-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
select.did-floating-select::-ms-expand {
  display: none;
}
.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
.did-floating-select:not([value=""]):valid ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  /* identical to box height, or 133% */
  letter-spacing: 0.5px;
  /* M3/sys/light/primary */
  color: var(--m3--sys--light--primary);
}
.did-floating-select[value=""]:focus ~ .did-floating-label {
  top: 20px;
  font-size: 13px;
}
.did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
  background-position: right 15px top 50%;
  background-repeat: no-repeat;
}

.lead-d-loader {
  background: transparent !important;
}

.f-20 {
  font-size: 20px !important;
}

.language-select-area {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
  padding-left: 10px;
}

.language-select-area select {
  text-align: center;
}
.language-select-area i {
  position: absolute;
  z-index: 9;
  align-items: center;
  margin-left: 15px;
  color: var(--m3--sys--light--primary);
  font-size: 24px;
}

.btn-not-enough {
  background-color: var(--m3--sys--light--error) !important;
  color: var(--m3--sys--light--on-primary) !important;
}

.btn-not-enough:hover {
  color: var(--m3--sys--light--error);
  background-color: var(--m3--sys--light--on-primary);
  border: 1px solid var(--m3--sys--light--error);
}
.lead-detail-information-right-box {
  background-color: #fff;
  padding: 0px 20px;
  border-radius: 25px;
}
.lead-detail-head-title {
  background-color: #fff;
  border-radius: 25px;
}
</style>
